import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { DialogsActions } from './actions';

export const dialogReducer = createReducer(
  initialState,
  on(DialogsActions.setRef, (state, { ref }) => ({
    ...state,
    ref,
  })),
);
